import { Form, Input, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { RecoilState, useRecoilState } from "recoil";
import { apiEditCompany } from "../../../../../api/api";
import { CompanyType } from "../../../../../types";

export const ModalEditCompany = ({
  modalState,
  updateDataSource,
}: {
  modalState: RecoilState<CompanyType | undefined>;
  updateDataSource: React.Dispatch<React.SetStateAction<CompanyType[]>>;
}) => {
  const [form] = Form.useForm<any>();
  const [editedCompany, setEditedCompany] = useRecoilState(modalState);
  const [loading, setLoading] = useState<boolean>(false);

  const editCompany = async (values: { [index: string]: string }) => {
    setLoading(true);
    const { companyName, login, inn } = values;
    if (!editedCompany) {
      setLoading(false);
      return;
    }
    const newInn = inn === editedCompany.inn ? undefined : inn;
    try {
      const resp = await apiEditCompany(
        companyName,
        login,
        editedCompany.inn,
        newInn
      );
      if (newInn && resp.result.inn !== newInn) {
        message.warning(
          "У данной организации имеются заведённые дела, изменение ИНН невозможно"
        );
        if (
          companyName === editedCompany.companyName &&
          login === editedCompany.login
        )
          return;
      }
      updateDataSource((oldArray) => {
        const rowToEdit = oldArray.findIndex(
          (row) => row.inn === editedCompany?.inn
        );
        const newDataSource = [...oldArray];
        newDataSource[rowToEdit] = {
          companyName: resp.result.companyName,
          login: resp.result.login,
          inn: resp.result.inn,
        };
        return newDataSource;
      });
      message.success("Организация отредактирована");
    } finally {
      setLoading(false);
    }
    setEditedCompany(undefined);
  };

  useEffect(() => {
    if (editedCompany) {
      form.setFields([
        {
          name: "companyName",
          value: editedCompany.companyName,
        },
        {
          name: "login",
          value: editedCompany.login,
        },
        {
          name: "inn",
          value: editedCompany.inn,
        },
      ]);
    }
  }, [editedCompany]);

  return (
    <Modal
      title="Редактировать"
      visible={!!editedCompany}
      onOk={() => form.submit()}
      onCancel={() => setEditedCompany(undefined)}
      confirmLoading={loading}
      afterClose={() => {
        form.resetFields();
      }}
      maskClosable={false}
      width="500px"
      cancelText="Отменить"
      okText="Сохранить"
      forceRender
    >
      <Form
        form={form}
        onFinish={editCompany}
        labelCol={{
          span: 7,
        }}
      >
        <Form.Item label="Название организации" name="companyName">
          <Input />
        </Form.Item>
        <Form.Item label="Логин" name="login">
          <Input />
        </Form.Item>
        <Form.Item label="ИНН" name="inn">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
